import { useEffect, useState } from "react"
import { Breadcrumb } from "~/types";
import { backButtonNextToBreadcrumb } from "../../../setup/settings/__product";
import { BackButton } from "../elements/BackButton.client";

export default function ProductsBreadcrumb({ className }: { className?: string }) {

    const [breadcrumb, setBreadcrumb] = useState<Breadcrumb[] | undefined>();


    useEffect(() => {
        try {
            setBreadcrumb(JSON.parse(localStorage.bdcb));
        }
        catch {
            setBreadcrumb(undefined);
        }
    }, [])

    return (
        <div className={className ? className : "ProductTop__breadcrumb"}>
            <div className="breadcrumb-container">
                <a href="/" title="Home">Home</a>
                {breadcrumb?.map(bc =>
                    <><span aria-hidden="true"> › </span><a href={`/collections/${bc.handle}/products`} title="Home">{bc.label}</a></>
                )}
            </div>
            {backButtonNextToBreadcrumb.enabled && (
                <BackButton />
            )}
        </div>
    )
}